import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { getDefaultEuiMarkdownUiPlugins } from './ui_plugins';
import { getDefaultEuiMarkdownParsingPlugins } from './parsing_plugins';
import { getDefaultEuiMarkdownProcessingPlugins } from './processing_plugins';
export var getDefaultEuiMarkdownPlugins = function getDefaultEuiMarkdownPlugins() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var exclude = config.exclude,
    processingConfig = config.processingConfig,
    parsingConfig = config.parsingConfig,
    uiConfig = config.uiConfig;
  return {
    parsingPlugins: getDefaultEuiMarkdownParsingPlugins(_objectSpread({
      exclude: exclude
    }, parsingConfig)),
    processingPlugins: getDefaultEuiMarkdownProcessingPlugins(_objectSpread({
      exclude: exclude
    }, processingConfig)),
    uiPlugins: getDefaultEuiMarkdownUiPlugins(_objectSpread({
      exclude: exclude
    }, uiConfig))
  };
};